import store from '@/store/index.js'
let dic = store.state.dic;
import { isNumSymbol } from "@/libs/checker.js";
export default function Configs(that) {
    // 密码验证
    var validatePass = (rule, value, callback) => {
        if (value === "") {
            callback(new Error("请输入密码"));
        } else {
            if (!isNumSymbol(value)) {
                callback(new Error("请输入密码，8-20个字符，由数字和大小写字母及特殊字符组合"));
            } else {
                if (that.handleData.verifyPassword !== "") {
                    that.$refs.cForm.$refs.cForm.validateField("verifyPassword");
                }
                callback();
            }
        }
    };
    var validatePass2 = (rule, value, callback) => {
        if (value === "") {
            callback(new Error("请再次输入密码"));
        } else if (value !== that.handleData.newPassword) {
            callback(new Error("两次输入密码不一致!"));
        } else {
            callback();
        }
    };

    const formItems = [
        {
            label: "旧密码",
            span: 24,
            placeholder: '请输入旧密码',
            model: "oldPassword",
            password: true,
        },
        {
            label: "新密码",
            span: 24,
            placeholder: '请输入新密码，8-20个字符，由数字和大小写字母及特殊字符组合',
            model: "newPassword",
            password: true,
        },
        {
            label: "密码确认",
            span: 24,
            placeholder: '请再次输入密码',
            model: "verifyPassword",
            password: true,
        },
    ]

    const formRules = {
        oldPassword: [{
            required: true,
            message: '请输入旧密码',
            trigger: "blur",
        }],
        newPassword: [{
            required: true,
            // message: '请输入新密码',
            trigger: "blur",
            validator: validatePass
        }],
        verifyPassword: [{
            required: true,
            trigger: "blur",
            validator: validatePass2
        }],
    }

    return {
        formItems,
        formRules,
    }
}
